import { path } from 'ramda';
import { getHasAppointment } from './selectors';
import {
  redirectToAppointments,
  redirectToRegister,
} from '../../main/payment/actions';
import { resetOrder } from '../../register/order/actions';
import { HIDE_RECEIPT, SHOW_RECEIPT } from './constants';
import { redirectToReceipt } from './actions';
import { getSaleSource } from '../../register/source/selectors';
import { resetSaleSource } from '../../register/source/actions';

const middleware = store => next => (action) => {
  next(action);
  const state = store.getState();

  const redirectToNextMasterScreen = () => {
    if (getHasAppointment(state)) {
      store.dispatch(redirectToAppointments());
      return;
    }
    if (getSaleSource(state) === 'appointment_product') {
      store.dispatch(redirectToAppointments());
      store.dispatch(resetSaleSource());
      return;
    }
    store.dispatch(redirectToRegister());
  };

  const showReceipt = () => {
    store.dispatch(redirectToReceipt(path(['payload', 'id'], action)));
  };

  const hideReceipt = () => {
    store.dispatch(resetOrder());
    redirectToNextMasterScreen();
  };

  switch (action.type) {
    case SHOW_RECEIPT:
      showReceipt();
      break;

    case HIDE_RECEIPT:
      hideReceipt();
      break;

    default:
  }
};

export default middleware;
